<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import ReportPageHeader from "@/components/report-page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { manageReportService } from "../../../../services/managements/reports/report.service.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Debt Amount Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    ReportPageHeader,
    Button,
    Input,
    Select, 
  },
  data() {
    return {
      title: "Debt Amount Report",
      data: [],
      projects: {},

      dataProjectId: 0,
      dataMonth: (moment().month() + 1) <10 ? '0'+(moment().month() + 1): (moment().month() + 1),
      dataYear: moment().year(),
      dataStartDate: '',
      dataEndDate: '',
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadReport();
    
  },
  methods: {
    
    loadReport: function() {
      let data = '?project_id='+this.dataProjectId+
        '&start_date='+this.dataStartDate+
        '&end_date='+this.dataEndDate
      
      manageReportService.getDebtAmountSummaryReport(data)
        .then(response => {
          console.log(response);
          this.data = response.data;
          this.dataStartDate = this.data.date.start_date;
          this.dataEndDate = this.data.date.end_date;
        });
        
    },
    submitSearch: function() {
      this.loadReport();
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    moment: function () {
      return moment();
    },
    formatCurrency(value) {
      if(value == 0 ){
        return '$0.00';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    },
    total(column_name, data){
      if(data){
        let total = 0;
        data.map(function(item){
            total += item[column_name];
        });

        return total;
      }
     
     
    }
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="'របាយការណ៍របំណុលសរុប'" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              
              <div class="col-sm-2">
                <label>គម្រោង</label>
                <Select
                  :id="'id'"
                  :text="'name'"
                  :editable="true"
                  :list="{data: this.data.projects}"
                  v-model="dataProjectId"
                /> 
              </div>
              <div class="col-sm-2">
                <!-- <label>ខែ</label> -->
                <!-- <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.data.date.months}"
                  v-model="dataMonth"
                />  -->
                  <Input
                    :type="'date'"
                    :id="'invoice_date'"
                    v-model="dataStartDate"
                    :label="'manage.start-date'"
                  />
              </div>
              
               <div class="col-sm-2">
                 <!-- <label>ឆ្នាំ</label> -->
                <!-- <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.data.date.years}"
                  v-model="dataYear"
                />  -->
                  <Input
                    :type="'date'"
                    :id="'end-date'"
                    v-model="dataEndDate"
                    :label="'manage.start-date'"
                  />
              </div>
              <div class="col-sm-2 pt-2">
                <br>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <ReportPageHeader
              :title="'របាយការណ៍របំណុលសរុប'"
              :titleDate="this.data.date?(this.data.date.start_date_kh + ' ដល់ ' + this.data.date.end_date_kh):''"
            />
            <section class="content">
              <div class="row py-2">
                <div class="col-7 text-end kh">បំណុលចាស់គិតត្រឹម{{this.data.date.start_date_kh}}</div>
                <div class="col text-end kh">{{formatCurrency(this.data.old_debt_amount)}}</div>
              </div>
              <div class="row py-2">
                <div class="col-7 text-end kh">សងបំណុលចាស់ក្នុងគិតពី{{this.data.date.start_date_kh + ' ដល់ ' + this.data.date.end_date_kh}}</div>
                <div class="col text-end kh">{{formatCurrency(this.data.paid_old_debt_amount)}}</div>
              </div>
              <div class="row py-2">
                <div class="col-7 text-end kh">បំណុលចាស់ដែលនៅសល់</div>
                <div class="col text-end kh">{{formatCurrency(this.data.current_old_debt_amount)}}</div>
              </div>
              <div class="row py-2">
                <div class="col-7 text-end kh">បំណុលថ្មីគិតពី{{this.data.date.start_date_kh + ' ដល់ ' + this.data.date.end_date_kh}}</div>
                <div class="col text-end kh">{{formatCurrency(this.data.new_debt_amount)}}</div>
              </div>
              <div class="row py-2">
                <div class="col-7 text-end kh">បំណុលសរុបគិតពី{{this.data.date.start_date_kh + ' ដល់ ' + this.data.date.end_date_kh}}</div>
                <div class="col text-end kh">{{formatCurrency(this.data.total_debt_amount)}}</div>
              </div>
           
            </section>

            <div class="row mt-3">
              <div class="col text-center">
                <p>ឯកភាព និងទទួលស្គាលើដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>លោកនាយកក្រុមហ៊ុន</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>អ្នកគ្រប់គ្រងទូទៅ</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>ជំនួយការអ្នកគ្រប់គ្រង</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>បុគ្គលិក</p>
              </div>
            </div>
            <br>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>